import React, { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useVisibility } from "@/contexts/VisibilityContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { GodModePanel } from "@/components/admin/GodModePanel";
import { Shield } from "lucide-react";

export function AdminStatusBadge() {
  const { isAdmin } = useAuth();
  const { counts } = useVisibility();

  const totalFlags = useMemo(() => counts.hidden + counts.member + counts.admin, [counts]);

  if (!isAdmin) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <Sheet>
        <SheetTrigger asChild>
          <Button className="glass-card border-border/60 shadow-lg gap-2">
            <Shield className="h-4 w-4" />
            <span>System Status</span>
            {totalFlags > 0 && <Badge variant="secondary">{totalFlags}</Badge>}
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-[420px] sm:w-[520px] flex flex-col">
          <SheetHeader>
            <SheetTitle>God Mode Controls</SheetTitle>
          </SheetHeader>
          <div className="flex-1 overflow-y-auto pr-2">
            <GodModePanel />
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
